import React from 'react';
// import data
import { features } from '../data';

const Feature2 = () => {
  // destructure features
  const { feature2 } = features;
  // destructure feature2
  // const { pretitle, title, subtitle, btnLink, btnIcon, image, title1 } = feature2;
  const { image, title1, title2 } = feature2;
  return (
    <section className='section'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row lg:items-center lg:gap-x-[30px]'>
          {/* image */}
          <div
            className='flex-1 order-1 lg:order-1'
            data-aos='fade-right'
            data-aos-offset='300'
          >
            <img src={image} alt='' className=' animate-pulse'/>
          </div>
          {/* text */}
          <div
            className='flex-1 order-1 lg:order-2 '
            data-aos='fade-left'
            data-aos-offset='400'
          >
            {/* <div className='pretitle  text-black'>{pretitle}</div>
            <h2 className='title  text-black'>{title}</h2> */}
            <p className='lead text-black justify-center text-center'>{title1}</p>
            <p className='lead text-black justify-center text-center'>{title2}</p>
            {/* <button className='btn-link flex items-center gap-x-3 hover:gap-x-5 transition-all'>
              {btnLink} <img src={btnIcon} alt='' />
            </button> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feature2;
